<section>
  <div class="container mt-3">
    <form>
      <button class="btn btn-success" (click)="abrirUsr(0)">Nuevo Usuario</button>
      <table class="table mt-3 table-hover table-sm table-responsive table-bordered border-dark text-center">
        <thead class="table-dark">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Nombre Completo</th>
            <th scope="col">Usuario</th>
            <th scope="col">Acción</th>
          </tr>
        </thead>
        <tbody class="table-light">
          <tr *ngFor="let m of usuarios">
              <th>{{m.id}}</th>
              <th>{{m.nombre}}</th>
              <th>{{m.email}}</th>
              <th>
                <button type="button" class="btn btn-primary btn-sm" (click)="abrirUsr(m.id)">Modificar</button>
              </th>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</section>